import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function MentionsLegales() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Mentions Légales</h1>
        
        <div className="prose prose-slate max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-pink-600">1. Éditeur du site</h2>
            <p>
              <strong>Raison sociale :</strong> Formation Pressing Sakura<br />
              <strong>SIRET :</strong> 932 576 515 00013<br />
              <strong>Adresse :</strong> Coinaud, 26140 Saint-Rambert-d'Albon, France<br />
              <strong>Téléphone :</strong> 07 66 83 30 51<br />
              <strong>Email :</strong> contact@pressing-sakura.fr
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">2. Hébergement</h2>
            <p>
              Le site est hébergé par :<br />
              <strong>Vercel Inc.</strong><br />
              340 S Lemon Ave #4133<br />
              Walnut, CA 91789, USA
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">3. Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site (textes, images, logo, etc.) est la propriété exclusive 
              de Formation Pressing Sakura, sauf mention contraire. Toute reproduction, distribution, 
              modification ou utilisation sans autorisation préalable est interdite.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">4. Données personnelles</h2>
            <p>
              Les informations collectées sur ce site sont destinées à Formation Pressing Sakura 
              pour la gestion des réservations et la relation client. Conformément au RGPD, vous 
              disposez d'un droit d'accès, de rectification et de suppression de vos données.
            </p>
            <p>
              Pour exercer ces droits, contactez-nous par email ou consultez notre{" "}
              <a href="/confidentialite" className="text-pink-600 underline">
                Politique de Confidentialité
              </a>.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">5. Cookies</h2>
            <p>
              Ce site utilise des cookies techniques nécessaires à son bon fonctionnement. 
              Ces cookies ne collectent pas de données personnelles à des fins publicitaires.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">6. Limitation de responsabilité</h2>
            <p>
              Formation Pressing Sakura s'efforce de fournir des informations exactes et à jour. 
              Toutefois, nous ne pouvons garantir l'exactitude de toutes les informations présentes 
              sur le site et déclinons toute responsabilité en cas d'erreur ou d'omission.
            </p>
          </section>
        </div>
        
        <p className="text-sm text-slate-400 mt-12 text-center">
          Dernière mise à jour : Septembre 2026
        </p>
      </div>
    </div>
  );
}
